export default __webpack_public_path__ + "static/media/banner_error.3eb42a14.jpg";